export const load = (name) => () => import(`@/views/${name}.vue`)
